/**
 * Ports legacy's actual static contact panel (`Views/Home/_HelpAndSupport.cshtml`, shown there inside a
 * "Help & Support" modal) rather than inventing a ticketing system EPN doesn't have. The reference
 * screenshot shows "Support" and "Help & Support" as two separate menu rows even though legacy renders
 * them as one thing — this page is the real one; see HelpSupportPage for the placeholder half.
 */
export function SupportPage() {
  return (
    <section className="card card--wide">
      <h1>Support</h1>
      <p>
        For assistance with Escochex Payroll, please contact us via email at{' '}
        <a href="mailto:payroll@escochecks.com">payroll@escochecks.com</a> or call us at{' '}
        <a href="tel:+17472237035">+1 (747) 223-7035</a> or <a href="tel:+17472021866">+1 (747) 202-1866</a>.
        Our support team will respond as quickly as possible.
      </p>
      <p>
        <strong>Need help processing payroll?</strong>
        <br />
        View the <a href="https://www.escochex.com/faqs" target="_blank" rel="noreferrer">Escochex Payroll Manual</a>.
      </p>
    </section>
  );
}
